module.exports = __webpack_public_path__ + "img/img_empty.4b7b27f4.png";